import PropTypes from 'prop-types';
import fields from './fields';
import { Info } from 'lucide-react';
import { FormGroup, Label, DefaultTooltip } from 'twyne-new.ui'
import TcpaConsentDbaTriggerButton from '@Components/tcpaConsentDba/TriggerButton';

const CustomField = ({ field, config, value, extra, onChange, extraValues }) => {
  const type = config.type || 'string';
  const Field = fields[type];
  const keys = Object.keys(config.options || {})
  const tagOtions = keys.map(tag => { return { label: config.options[tag] , value: tag }}) || {}
  const unallowedLabel = ['group', 'tab', 'has-many']

  if(Field === undefined)
    return (
      <FormGroup>
        <Label>{config.name || field }</Label><br/>
          <b>Can't find config type: {config.type}</b>
      </FormGroup>
    )

  return (
    <FormGroup>
      {(unallowedLabel.indexOf(type) < 0 && !config.removeName) && (
        <Label className="items-center justify-between flex">
          {config.name || field }
          {config.hint && !unallowedLabel.includes(type) && (
              <>
                <DefaultTooltip content={config.hint} side='top'>
                  <Info size='16' className='twy-text-accent ml-1' />
                </DefaultTooltip>
              </>
            )}
          {field === 'tcpa-consent-text' && <>
            <TcpaConsentDbaTriggerButton
              tcpaConsentText={extraValues.tcpaConsentText}
              tcpaConsentDba={extraValues.tcpaConsentDba}
            />
          </>}
        </Label>
      )}
        <Field
          name={field}
          value={value || ''}
          onChange={(e) => onChange(field, e)}
          options={tagOtions || {}}
          config={config}
          extra={extra}
        />
    </FormGroup>
  )
}

CustomField.propTypes = {
  field: PropTypes.string,
  config: PropTypes.object,
  extra: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.any
}

export default CustomField;
